import React from 'react';

import styled from 'styled-components';

import { NwAddButton, NwLinkButton } from '@components/Gui/NwButton';
import NwSegmented from '@components/Gui/NwForm/NwSegmented';

import { BOOKS_SORT_OPTIONS } from './modelDetailsBooks.utils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/** Su mobile ordinamento e nuovo book vanno a capo quando non stanno sulla stessa riga. */
const MobileCardExtra = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 0.75rem;

    .mobile-add-book {
        margin-left: auto;
    }
`;

const BooksDrawerCardExtra = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    min-width: 0;
`;

const ModelDetailsBooksCardHeaderActions = ({
    booksDrawer,
    booksSort,
    fastPackageOnly,
    hasAnyFastPackage,
    isMobile,
    onBooksSortChange,
    onOpenAddBookDrawer,
    onToggleFastPackageOnly,
    scope,
}) => {
    if (isMobile) {
        return (
            <MobileCardExtra>
                <NwSegmented
                    size="small"
                    options={BOOKS_SORT_OPTIONS}
                    onChange={onBooksSortChange}
                    value={booksSort}
                />
                <NwAddButton
                    className="mobile-add-book"
                    size="small"
                    ghost
                    onClick={onOpenAddBookDrawer}
                    label="new book"
                />
            </MobileCardExtra>
        );
    }

    if (booksDrawer) {
        return (
            <BooksDrawerCardExtra>
                <div>
                    {hasAnyFastPackage && (
                        <NwLinkButton
                            size="small"
                            icon={fastPackageOnly ? byPrefixAndName.fasl['list'] : byPrefixAndName.fasl['truck-fast']}
                            label={fastPackageOnly ? 'all books' : 'sort fast packages'}
                            style={{ fontWeight: fastPackageOnly ? 600 : 400 }}
                            onClick={onToggleFastPackageOnly}
                        />
                    )}
                </div>
                <NwAddButton
                    size="small"
                    primary={scope !== 'model-details'}
                    ghost={scope === 'model-details'}
                    onClick={onOpenAddBookDrawer}
                    label="new book"
                />
            </BooksDrawerCardExtra>
        );
    }

    return (
        <NwAddButton
            size="small"
            primary={scope !== 'model-details'}
            ghost={scope === 'model-details'}
            onClick={onOpenAddBookDrawer}
            label="new book"
        />
    );
};

export default ModelDetailsBooksCardHeaderActions;
